import { Database } from 'types/supabase'
import { supabaseClient } from 'supabase'

export type CityRow = Database['public']['Tables']['cities']['Row']

export const listCities = async (): Promise<CityRow[]> => {
  const { data, error } = await supabaseClient
    .from('cities')
    .select('*')
    .order('name')

  if (error) {
    throw error
  }

  return data || []
}
